import React, { useState } from "react";
import "./webPortalLogin.scss";
import AllServices from "../../../Services/AllServices";
import { useNavigate, useLocation } from "react-router-dom";
import CustomLoaderBoxy from "../../../components/CustomLoader/CustomLoaderBoxy";
import { toast } from "react-toastify";

const WebPortalLogin = () => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    userName: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataObj = {
      userName: form.userName,
      password: form.password,
    };
    try {
      setLoading(true);
      const response = await AllServices.loginWebPortal(dataObj);

      if (!response.data.succuss) {
        toast.error(response.data.message);
      }

      if (response.data.succuss) {
        toast.success(response.data.message);
        navigate("/adminuser/webportal/step_1", {
          state: { refNumber: state?.refNumber },
        });
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wp-login-container">
      {loading && (
        <div className="loader-overlay">
          <CustomLoaderBoxy />
        </div>
      )}

      <div className="wp-login-box">
        <div className="login-header">
          Servizio Alloggiati – Accesso al Sistema
        </div>

        <div className="login-body">
          <div className="input-group">
            <span className="input-icon">👤</span>
            <input
              type="text"
              placeholder="Utente"
              onChange={handleChange}
              name="userName"
            />
          </div>
          <div className="input-group">
            <span className="input-icon">🔒</span>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              onChange={handleChange}
              name="password"
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁️‍🗨️"}
            </span>
          </div>

          <div className="wp-button-group">
            <button className="accept-btn" onClick={handleSubmit}>
              Accedi
            </button>

            <button
              className="canccel-btn"
              onClick={() => navigate("/adminuser/views")}
            >
              Annulla
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebPortalLogin;
